/**
 * @generated SignedSource<<0fc180c21e119b92ab3f8447def9d388>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoveOption_node$data = {
  readonly __typename: string;
  readonly canMove?: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly root?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  };
  readonly " $fragmentType": "MoveOption_node";
};
export type MoveOption_node$key = {
  readonly " $data"?: MoveOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoveOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoveOption_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canMove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "root",
          "args": [
            {
              "kind": "Literal",
              "name": "last",
              "value": 1
            }
          ],
          "concreteType": "FolderNodeConnection",
          "kind": "LinkedField",
          "name": "ancestors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FolderNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "Folder",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "ancestors(last:1)"
        }
      ],
      "type": "FolderNodeInterface",
      "abstractKey": "__isFolderNodeInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "05c6ae813c7ef63816f519dafdede47c";

export default node;
